import { CHESS_PHASE_TICKS, colorToMove, type ChessColor, type State } from '@chessshooter/shared';

/** Keeps the entry cue tied to the starting position, including a move on the first playable tick. */
export class ChessEntryCue {
  private phaseEnd: number | null = null;
  private entryFen: string | null = null;

  update(state: State): ChessColor | null {
    if (state.phase !== 'chess' || state.winner !== null) {
      this.phaseEnd = null;
      this.entryFen = null;
      return null;
    }
    // The end advances while the countdown shrinks, so their sum identifies the whole phase.
    const phaseEnd = state.phaseEndsAtTick + state.transitionTicks;
    if (phaseEnd !== this.phaseEnd) {
      this.phaseEnd = phaseEnd;
      this.entryFen = state.chess.lastMoveTick <= state.phaseEndsAtTick - CHESS_PHASE_TICKS
        ? state.chess.fen : null;
    }
    return state.transitionTicks === 0 && state.chess.fen === this.entryFen
      ? colorToMove(state) : null;
  }
}
